import React from 'react';
import { useNavigate } from 'react-router-dom';
import { useTheme } from '../../../contexts/ThemeContext';
import GenericListWidget from './GenericListWidget';
import { useSupplyInvoices, type SupplyInvoice } from '../../supplies/supply-invoices/useData';
import { formatDate } from '../../../config/appConfig';

const ScmsRecentInvoices: React.FC<{ limit?: number; embedded?: boolean; settings?: Record<string, unknown> }> = ({
  limit = 5,
  embedded,
  settings,
}) => {
  const navigate = useNavigate();
  const { colors } = useTheme();
  const effectiveLimit = typeof settings?.limit === 'number' ? settings.limit : limit;
  const { data, isLoading } = useSupplyInvoices(undefined, 1, 50);

  const items = [...(data ?? [])]
    .sort((a, b) => new Date(b.invDate || b.createdAt).getTime() - new Date(a.invDate || a.createdAt).getTime())
    .slice(0, effectiveLimit);

  return (
    <GenericListWidget<SupplyInvoice>
      title="Supplies · Recent Invoices"
      viewAllPath="/supplies/supply-invoices"
      data={items}
      isLoading={isLoading}
      limit={effectiveLimit}
      emptyMessage="No invoices"
      getItemKey={(inv) => inv.id}
      embedded={embedded}
      renderItem={(invoice) => (
        <div
          onClick={() => navigate(`/supplies/supply-invoices/${invoice.id}`)}
          className="flex items-center justify-between gap-3 p-2 rounded-lg hover:bg-gray-50 dark:hover:bg-gray-800/40 cursor-pointer"
        >
          <div className="min-w-0">
            <p className={`text-sm font-medium truncate ${colors.text}`}>{invoice.ref || `Invoice #${invoice.id}`}</p>
            <p className={`text-xs ${colors.textMuted}`}>{invoice.supplier?.name || 'No supplier'}</p>
          </div>
          <span className={`text-xs whitespace-nowrap ${colors.textMuted}`}>{formatDate(invoice.invDate || invoice.createdAt)}</span>
        </div>
      )}
    />
  );
};

export default ScmsRecentInvoices;
